import React from "react";
import { expertiseData } from "../Data/data"
import CountUp from 'react-countup';
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll';

export default function AboutUs() {

    return (
        <section className="relative md:py-24 py-16" id="about">
            <div className="container">
                <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
                    <div className="lg:col-span-5 lg:px-8">
                        <div className="relative">
                            <div className="absolute inset-0 border dark:border-gray-800 rounded-full -mt-[10px] -ms-3 h-[100%] w-[100%] -z-1"></div>
                            <img src="/images/hero/88.jpg" className="rounded-full shadow-md shadow-gray-200 dark:shadow-gray-800" alt="" />

                            {/* <div className="absolute lg:bottom-20 md:bottom-10 bottom-6 ltr:lg:-right-16 rtl:lg:-left-16 ltr:md:-right-8 rtl:md:-left-8 ltr:right-0 rtl:left-0 p-4 rounded-lg shadow-md dark:shadow-gray-800 bg-white dark:bg-slate-900 m-3 w-44 text-center">
                                <h6 className="font-semibold">Web Desinger</h6>
                                <span className="text-2xl font-medium text-amber-500 mb-0"><span className="counter-value font-bold" data-target="7"><CountUp
                                            start={7}
                                            className="counter-value"
                                            end={180}
                                            duration={2.75} /></span>+</span>
                                <span className="text-sm text-slate-400">Years <br/> Experience</span>
                            </div> */}
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="lg:ms-5">
                            <h3 className="mb-6 md:text-2xl text-xl md:leading-normal leading-normal font-semibold"> CEO of Demetrix Infotech</h3>

                          <p className="text-slate-400 max-w-xl text-[15px]">
I am Pramod John, a development practitioner with over three decades of experience in garments, cotton, labour rights, ethical trade, farmer empowerment, and sustainability. My most defining work comes from the Tirupur garment cluster and the cotton-growing regions of central India, where I helped build systems that protect workers, empower farmers, and bring transparency into complex supply chains.
</p>

<p className="text-slate-400 max-w-xl text-[15px] mt-4">
Beginning with deep field research, my work evolved into institution-building, policy reform, supply chain transformation, and environmental advocacy. I have collaborated with trade unions, NGOs, global brands, buyers, auditors, industry leaders, and farmer cooperatives, bringing them onto one platform.
</p>

<p className="text-slate-400 max-w-xl text-[15px] mt-4">
I have authored key publications such as <i>Knitted Together</i>, <i>Steering Corporate Social Responsibility</i>, and <i>Burning Issue</i>, and co-founded the Tirupur Steering Group (TSG) — one of India’s most respected multi-stakeholder accountability platforms. I also support farmer-owned cotton institutions like Chetna Organic and COPCOL, strengthening ethical and sustainable sourcing.
</p>

<p className="text-slate-400 max-w-xl text-[15px] mt-4">
At the heart of my work is a simple belief: workers and farmers deserve dignity, transparency, and power in the systems built on their labour.
</p>

<p className="text-slate-400 max-w-xl text-[15px] mt-4">
I continue to advocate for fair, ethical, and sustainable garment and cotton supply chains, where human rights, living wages, safety, and environmental responsibility are non-negotiable.
</p>

                            <div className="mt-6">
                                <Link1 to="project" className="btn bg-amber-500/10 hover:bg-amber-500 border-amber-500/10 hover:border-amber-500 text-amber-500 hover:text-white rounded-md me-2 mt-2">See Work</Link1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="container md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl md:leading-normal leading-normal font-semibold">Hobbies & Expertise</h3>

                    <p className="text-slate-400 max-w-xl mx-auto text-[15px]">Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development.</p>
                </div>

                <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 mt-8 gap-[30px]">
                    {expertiseData.map((item, index) => {
                        const Icon = item.Icon
                        return (
                            <div className="flex group shadow shadow-gray-200 dark:shadow-gray-800 dark:hover:shadow-gray-700 items-center p-3 rounded-lg bg-white dark:bg-slate-900" key={index}>
                                <div className="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-amber-500/10 group-hover:bg-amber-500 text-amber-500 group-hover:text-white text-center rounded-xl me-5 transition-all duration-500">
                                    <div className="rotate-45">
                                        <Icon className="h-5 w-5" />
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <h4 className="mb-0 text-[17px] font-medium">{item.title}</h4>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div> */}
        </section>
    )
}